import {
  NetworkUtilsService,
  URL_DICT,
} from 'projects/app-core/src/service/network-utils.service';
import { AdminCreateOrUpdatePacksRequest, AdminGetPacksResponse } from '../models/packs/AdminCreateOrUpdatePacksRequest';
import { Injectable } from '@angular/core';
import { AnyoPacksGridRequest } from '../models/packs/AnyoPacksGridRequest';
import { AnyoPackGridResponse } from '../models/packs/AnyoPacksGridResponse';
import { AnyoPackSubscriptionGridRequest } from '../models/packs/AdminPacksSubscriptionGridRequest';
import { AnyoPacksSubscriptionGridResponse } from '../models/packs/AnyoPacksSubscriptionGridResponse';
import { ChatMessage } from '../pages/packs/template-check/template-check.component';
import { AnyoPackSubscriptionAppResponse } from '../models/packs/AnyoPackSubscriptionAppResponse';

export enum AnyoPromptTemplates {
  ANALYSES_EXPERT_FEEDBACK = 'ANALYSES_EXPERT_FEEDBACK',
  ANYO_PACKAGES_CHAT = 'ANYO_PACKAGES_CHAT',
}

export enum AnyoPromptTemplateParams {
  PRIMARY_CONCERN = 'PRIMARY_CONCERN',
}

export interface ChatLLMAdminRequest {
  message: string;
  promptTemplateId: AnyoPromptTemplates;
  prompt: string;
  placeHolders: { key: string; value: string }[];
  chatSessionId: string;
}

export interface PromptTemplate {
  template?: string;
  outputFormat?: any;
  [key: string]: any;
}
export interface AdminActivateAnyoPackageRequest {
  userEmail: string;
  packId: string;
  variationId: string;
  auxiliaryConcernId: string;
  primaryTherapistId: string;
  auxiliaryTherapistId: string;
  auxiliaryPackExpertiseIds: string;
  paymentOrderId: string;
}
export interface AdminTransferTherapistPackSubscriptionRequest {
  packSubscriptionId: string;
  newTherapistId: string;
  expertiseId: string;
  transferConfirmedSessions: boolean;
  rescheduleSlots?: { sessionId: string; startTime: string; endTime: string }[];
  newSessionDateTime?: number;
  /** Completed sessions whose feedback is mailed to the new therapist. */
  feedbackSessionIds?: string[];
}
export interface AdminChangeAuxTherapistAndCencernRequest {
  packSubscriptionId: string;
  newTherapistId: string;
  concernId: string;
  newExpertiseId: string;
}
@Injectable({
  providedIn: 'root',
})
export class PackService {
  constructor(private api: NetworkUtilsService) { }
  public createOrUpdatePack(req: AdminCreateOrUpdatePacksRequest) {
    return this.api.post(URL_DICT.adminPacksCreateUrl, req);
  }
  public getPack(id: string) {
    return this.api.get<AdminGetPacksResponse>(
      URL_DICT.adminPacksGetUrl + id,
    );
  }
  public getPacksGrid(req: AnyoPacksGridRequest) {
    return this.api.post<AnyoPackGridResponse>(URL_DICT.adminPacksGridUrl, req);
  }
  public getPacksSubscriptionGrid(req: AnyoPackSubscriptionGridRequest) {
    return this.api.post<AnyoPacksSubscriptionGridResponse>(
      URL_DICT.adminPacksSubscriptionGridUrl,
      req,
    );
  }

  public adminActivatePackSubscription(req: AdminActivateAnyoPackageRequest) {
    return this.api.post(URL_DICT.adminActivatePackSubscriptionUrl, req);
  }
  public adminDeactivatePackSubscription(id: string) {
    return this.api.post(URL_DICT.adminDeactivatePackSubscriptionUrl, {
      packSubscriptionId: id,
    });
  }
  public adminTransferTherapistPackSubscription(
    req: AdminTransferTherapistPackSubscriptionRequest,
  ) {
    return this.api.post(
      URL_DICT.adminTransferTherapistPackSubscriptionUrl,
      req,
    );
  }
  public adminChangeAuxTherapist(
    req: AdminChangeAuxTherapistAndCencernRequest,
  ) {
    return this.api.post(URL_DICT.adminChangeAuxTherapist, req);
  }

  public getAnyoPromptTemplate(req: { templateId: AnyoPromptTemplates }) {
    return this.api.post<PromptTemplate>(
      URL_DICT.adminGetPromptLLMTemplate,
      req,
    );
  }

  public chatWithPrompt(req: ChatLLMAdminRequest) {
    return this.api.post<ChatMessage>(URL_DICT.adminTestPromptLLMTemplate, req);
  }

  public fetchActiveTherapyPacksForUser(userId: string) {
    const url = URL_DICT.adminFetchPackForUser + '?userId=' + userId;
    return this.api.get<AnyoPackSubscriptionAppResponse[]>(url);
  }
}
